import { apiCall } from './gqlClient';
const GETPUBLICVIDEOS_QUERY = "\n  query getPublicVideos($providerId: Int, $keyword: String, $webIntegrationId: Int) {\n    getPublicVideos(providerId: $providerId, keyword: $keyword, webIntegrationId: $webIntegrationId)\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getPublicVideosApiCall = async function (_ref) {
  let {
    providerId,
    keyword,
    webIntegrationId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPUBLICVIDEOS_QUERY,
    variables: {
      providerId,
      keyword,
      webIntegrationId
    },
    fragments
  });
};
const GETUSERVIDEOS_QUERY = "\n  query getUserVideos($userId: Int!) {\n    getUserVideos(userId: $userId)\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getUserVideosApiCall = async function (_ref2) {
  let {
    userId
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERVIDEOS_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const GETBOUGHTVIDEOS_QUERY = "\n  query getBoughtVideos($videoId: String) {\n    getBoughtVideos(videoId: $videoId)\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getBoughtVideosApiCall = async function (_ref3) {
  let {
    videoId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETBOUGHTVIDEOS_QUERY,
    variables: {
      videoId
    },
    fragments
  });
};
const GETMYVIDEOS_QUERY = "\n  query getMyVideos($providerId: Int, $keyword: String) {\n    getMyVideos(providerId: $providerId, keyword: $keyword)\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getMyVideosApiCall = async function (_ref4) {
  let {
    providerId,
    keyword
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMYVIDEOS_QUERY,
    variables: {
      providerId,
      keyword
    },
    fragments
  });
};
const GETVIDEOS_QUERY = "\n  query getVideos {\n    getVideos\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getVideosApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETVIDEOS_QUERY,
    variables: {},
    fragments
  });
};
const GETALLNOTACQUIREDUSERVIDEOS_QUERY = "\n  query getAllNotAcquiredUserVideos($userId: Int!) {\n    getAllNotAcquiredUserVideos(userId: $userId)\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getAllNotAcquiredUserVideosApiCall = async function (_ref5) {
  let {
    userId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETALLNOTACQUIREDUSERVIDEOS_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const GETARCHIVEDVIDEOS_QUERY = "\n  query getArchivedVideos {\n    getArchivedVideos\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getArchivedVideosApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETARCHIVEDVIDEOS_QUERY,
    variables: {},
    fragments
  });
};
const GETALLVIDEOS_QUERY = "\n  query getAllVideos {\n    getAllVideos\n    {\n      id\n\t\t\ttempProductId\n\t\t\tproviderId\n\t\t\tsvcTypeId\n\t\t\tprodGroupId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\torderIndex\n\t\t\tactive\n\t\t\tarchive\n\t\t\ttarget\n\t\t\timageUrl\n\t\t\tfileType\n\t\t\tcategoryName\n\t\t\tduration\n\t\t\tdurationType\n\t\t\talwaysAvailable\n      ...fragments\n    }\n  }";
export const getAllVideosApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETALLVIDEOS_QUERY,
    variables: {},
    fragments
  });
};
const GETVIDEOCOURSESYOUFEEL_QUERY = "\n  query getVideoCoursesYouFeel {\n    getVideoCoursesYouFeel\n  }";
export const getVideoCoursesYouFeelApiCall = async () => apiCall({
  query: GETVIDEOCOURSESYOUFEEL_QUERY,
  variables: {}
});
const GETUSERVIDEOCOURSESYOUFEEL_QUERY = "\n  query getUserVideoCoursesYouFeel {\n    getUserVideoCoursesYouFeel\n  }";
export const getUserVideoCoursesYouFeelApiCall = async () => apiCall({
  query: GETUSERVIDEOCOURSESYOUFEEL_QUERY,
  variables: {}
});
const GETVIDEOCOURSEFILESYOUFEEL_QUERY = "\n  query getVideoCourseFilesYouFeel($id: String!) {\n    getVideoCourseFilesYouFeel(id: $id)\n  }";
export const getVideoCourseFilesYouFeelApiCall = async _ref6 => {
  let {
    id
  } = _ref6;
  return apiCall({
    query: GETVIDEOCOURSEFILESYOUFEEL_QUERY,
    variables: {
      id
    }
  });
};
const GETUSERVIDEOCOURSEFILESYOUFEEL_QUERY = "\n  query getUserVideoCourseFilesYouFeel($id: String!) {\n    getUserVideoCourseFilesYouFeel(id: $id)\n  }";
export const getUserVideoCourseFilesYouFeelApiCall = async _ref7 => {
  let {
    id
  } = _ref7;
  return apiCall({
    query: GETUSERVIDEOCOURSEFILESYOUFEEL_QUERY,
    variables: {
      id
    }
  });
};
const ADDVIDEOTOUSER_QUERY = "\n  mutation addVideoToUser($productId: String!, $userId: Int!, $email: String, $startTime: DateTime, $endTime: DateTime, $paid: Int, $isPaid: Boolean, $method: String, $channel: String) {\n    addVideoToUser(productId: $productId, userId: $userId, email: $email, startTime: $startTime, endTime: $endTime, paid: $paid, isPaid: $isPaid, method: $method, channel: $channel)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const addVideoToUserApiCall = async function (_ref8) {
  let {
    productId,
    userId,
    email,
    startTime,
    endTime,
    paid,
    isPaid,
    method,
    channel
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDVIDEOTOUSER_QUERY,
    variables: {
      productId,
      userId,
      email,
      startTime,
      endTime,
      paid,
      isPaid,
      method,
      channel
    },
    fragments
  });
};
const ADDVIDEOTOGROUPOFUSERS_QUERY = "\n  mutation addVideoToGroupOfUsers($productId: String!, $groupId: Int!, $startTime: DateTime, $endTime: DateTime) {\n    addVideoToGroupOfUsers(productId: $productId, groupId: $groupId, startTime: $startTime, endTime: $endTime)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const addVideoToGroupOfUsersApiCall = async function (_ref9) {
  let {
    productId,
    groupId,
    startTime,
    endTime
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDVIDEOTOGROUPOFUSERS_QUERY,
    variables: {
      productId,
      groupId,
      startTime,
      endTime
    },
    fragments
  });
};
const SAVEVIDEO_QUERY = "\n  mutation saveVideo($request: ProductInput!) {\n    saveVideo(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const saveVideoApiCall = async function (_ref10) {
  let {
    request
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEVIDEO_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ARCHIVEVIDEO_QUERY = "\n  mutation archiveVideo($id: String!) {\n    archiveVideo(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveVideoApiCall = async function (_ref11) {
  let {
    id
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEVIDEO_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const TOGGLEVIDEOSTATUS_QUERY = "\n  mutation toggleVideoStatus($id: String!, $isPublished: Boolean!) {\n    toggleVideoStatus(id: $id, isPublished: $isPublished)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleVideoStatusApiCall = async function (_ref12) {
  let {
    id,
    isPublished
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEVIDEOSTATUS_QUERY,
    variables: {
      id,
      isPublished
    },
    fragments
  });
};
const TOGGLEVIDEOORDERSTATUS_QUERY = "\n  mutation toggleVideoOrderStatus($id: Int!, $active: Boolean!) {\n    toggleVideoOrderStatus(id: $id, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleVideoOrderStatusApiCall = async function (_ref13) {
  let {
    id,
    active
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEVIDEOORDERSTATUS_QUERY,
    variables: {
      id,
      active
    },
    fragments
  });
};
const RESTOREVIDEO_QUERY = "\n  mutation restoreVideo($id: String!) {\n    restoreVideo(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const restoreVideoApiCall = async function (_ref14) {
  let {
    id
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTOREVIDEO_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REORDERVIDEOS_QUERY = "\n  mutation reorderVideos($oldPosition: Int!, $newPosition: Int!) {\n    reorderVideos(oldPosition: $oldPosition, newPosition: $newPosition)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const reorderVideosApiCall = async function (_ref15) {
  let {
    oldPosition,
    newPosition
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERVIDEOS_QUERY,
    variables: {
      oldPosition,
      newPosition
    },
    fragments
  });
};
const DUPLICATEPRODUCT_QUERY = "\n  mutation duplicateProduct($id: String!) {\n    duplicateProduct(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const duplicateProductApiCall = async function (_ref16) {
  let {
    id
  } = _ref16;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DUPLICATEPRODUCT_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const CHANGEUSERVIDEOSTARTENDTIME_QUERY = "\n  mutation changeUserVideoStartEndTime($id: Int!, $startTime: DateTime!, $endTime: DateTime!) {\n    changeUserVideoStartEndTime(id: $id, startTime: $startTime, endTime: $endTime)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserVideoStartEndTimeApiCall = async function (_ref17) {
  let {
    id,
    startTime,
    endTime
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERVIDEOSTARTENDTIME_QUERY,
    variables: {
      id,
      startTime,
      endTime
    },
    fragments
  });
};